import { render, staticRenderFns } from "./TaskStatusDropdown.vue?vue&type=template&id=75558111"
import script from "./TaskStatusDropdown.vue?vue&type=script&lang=ts"
export * from "./TaskStatusDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports